"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
const HANDLE_SIZE = 10;
const LABEL_HEIGHT = 12;
const clampToImage = (offset, size, extent) => Math.min(Math.max(0, extent - size), Math.max(0, offset));
const MIN_TOLERANCE = 1e-3;
const clamp01 = (value) => Math.min(1, Math.max(0, value));
const toleranceFromCorner = (cursorX, cursorY, rightEdge, top) => Math.max(MIN_TOLERANCE, (cursorX - rightEdge + (top - cursorY)) / 2);
const orderedCoords = (coords) => {
  if (!isNum(coords.right) || !isNum(coords.bottom)) return coords;
  return {
    left: Math.min(coords.left, coords.right),
    top: Math.min(coords.top, coords.bottom),
    right: Math.max(coords.left, coords.right),
    bottom: Math.max(coords.top, coords.bottom)
  };
};
const RegionOverlay = React.createClass(
  {
    getInitialState() {
      return { drag: null };
    },
    wrapper: null,
    beginDrag(region, corner) {
      return (event) => {
        const { onRegionResize, imageWidth, imageHeight } = this.props;
        if (!onRegionResize) return;
        event.preventDefault();
        event.stopPropagation();
        let latest = {
          key: region.key,
          corner,
          left: region.left,
          top: region.top,
          right: region.right,
          bottom: region.bottom,
          tolerance: region.tolerance
        };
        const rightEdge = isNum(region.right) ? region.right : region.left;
        const toFraction = (e) => {
          const bounds = this.wrapper && this.wrapper.getBoundingClientRect();
          const originLeft = bounds ? bounds.left : 0;
          const originTop = bounds ? bounds.top : 0;
          return {
            left: clamp01((e.clientX - originLeft) / imageWidth),
            top: clamp01((e.clientY - originTop) / imageHeight)
          };
        };
        const onMove = (e) => {
          const { left, top } = toFraction(e);
          if (corner === "tolerance") {
            latest = __spreadProps(__spreadValues({}, latest), {
              tolerance: toleranceFromCorner(left, top, rightEdge, region.top)
            });
          } else if (corner === "bottomRight") {
            latest = __spreadProps(__spreadValues({}, latest), { right: left, bottom: top });
          } else {
            latest = __spreadProps(__spreadValues({}, latest), { left, top });
          }
          this.setState({ drag: latest });
        };
        const onUp = () => {
          window.removeEventListener("mousemove", onMove);
          window.removeEventListener("mouseup", onUp);
          this.setState({ drag: null });
          const ordered = orderedCoords(latest);
          onRegionResize([
            region.key,
            corner === "tolerance" ? __spreadProps(__spreadValues({}, ordered), { tolerance: latest.tolerance }) : ordered
          ]);
        };
        this.setState({ drag: latest });
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onUp);
      };
    },
    render() {
      const { regions, imageWidth, imageHeight, onRegionResize } = this.props;
      const { drag } = this.state;
      const wrapperStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        width: imageWidth,
        height: imageHeight,
        pointerEvents: "none",
        zIndex: 60
      };
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          "data-component": "RegionOverlay",
          style: wrapperStyle,
          ref: (el) => {
            this.wrapper = el;
          }
        },
        regions.map((region, index) => {
          const shown = drag && drag.key === region.key ? __spreadProps(__spreadValues(__spreadValues({}, region), orderedCoords(drag)), {
            tolerance: drag.tolerance
          }) : region;
          return regionView(
            shown,
            index,
            imageWidth,
            imageHeight,
            onRegionResize ? this.beginDrag : null
          );
        })
      );
    }
  }
);
const regionView = (region, index, imageWidth, imageHeight, beginDrag) => {
  const isBox = isNum(region.right) && isNum(region.bottom);
  const tol = region.tolerance;
  const innerRight = isNum(region.right) ? region.right : region.left;
  const innerBottom = isNum(region.bottom) ? region.bottom : region.top;
  const outer = rect(
    region.left - tol,
    region.top - tol,
    innerRight + tol,
    innerBottom + tol,
    imageWidth,
    imageHeight
  );
  const outerStyle = __spreadProps(__spreadValues({}, outer), {
    position: "absolute",
    border: `1px dashed ${region.color}`,
    boxSizing: "border-box"
  });
  const labelTop = outer.top - LABEL_HEIGHT >= 0 ? outer.top - LABEL_HEIGHT : outer.top;
  const label = /* @__PURE__ */ React.createElement(
    "span",
    {
      style: {
        position: "absolute",
        top: labelTop,
        left: clampToImage(outer.left, 0, imageWidth),
        background: region.color,
        color: "white",
        fontSize: 10,
        lineHeight: `${LABEL_HEIGHT}px`,
        padding: "0 3px",
        whiteSpace: "nowrap"
      }
    },
    region.label
  );
  return /* @__PURE__ */ React.createElement("div", { key: region.key || index }, /* @__PURE__ */ React.createElement("div", { style: outerStyle }), innerView(region, isBox, imageWidth, imageHeight), label, handles(region, isBox, imageWidth, imageHeight, beginDrag));
};
const innerView = (region, isBox, imageWidth, imageHeight) => {
  if (isBox && isNum(region.right) && isNum(region.bottom)) {
    const inner = rect(
      region.left,
      region.top,
      region.right,
      region.bottom,
      imageWidth,
      imageHeight
    );
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: __spreadProps(__spreadValues({}, inner), {
          position: "absolute",
          border: `2px solid ${region.color}`,
          background: `${region.color}22`,
          boxSizing: "border-box"
        })
      }
    );
  }
  const markerSize = 6;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: {
        position: "absolute",
        left: region.left * imageWidth - markerSize / 2,
        top: region.top * imageHeight - markerSize / 2,
        width: markerSize,
        height: markerSize,
        background: region.color,
        borderRadius: "50%"
      }
    }
  );
};
const handles = (region, isBox, imageWidth, imageHeight, beginDrag) => {
  if (!beginDrag) return null;
  const rightEdge = isNum(region.right) ? region.right : region.left;
  const toleranceHandle = handle(
    rightEdge + region.tolerance,
    region.top - region.tolerance,
    region.color,
    "nesw-resize",
    imageWidth,
    imageHeight,
    beginDrag(region, "tolerance")
  );
  if (isBox && isNum(region.right) && isNum(region.bottom)) {
    return /* @__PURE__ */ React.createElement("div", null, handle(
      region.left,
      region.top,
      region.color,
      "nwse-resize",
      imageWidth,
      imageHeight,
      beginDrag(region, "topLeft")
    ), handle(
      region.right,
      region.bottom,
      region.color,
      "nwse-resize",
      imageWidth,
      imageHeight,
      beginDrag(region, "bottomRight")
    ), toleranceHandle);
  }
  return /* @__PURE__ */ React.createElement("div", null, handle(
    region.left,
    region.top,
    region.color,
    "move",
    imageWidth,
    imageHeight,
    beginDrag(region, "point")
  ), toleranceHandle);
};
const handle = (left, top, color, cursor, imageWidth, imageHeight, onMouseDown) => /* @__PURE__ */ React.createElement(
  "div",
  {
    key: `${cursor}-${left}-${top}`,
    onMouseDown,
    style: {
      position: "absolute",
      left: clampToImage(
        left * imageWidth - HANDLE_SIZE / 2,
        HANDLE_SIZE,
        imageWidth
      ),
      top: clampToImage(
        top * imageHeight - HANDLE_SIZE / 2,
        HANDLE_SIZE,
        imageHeight
      ),
      width: HANDLE_SIZE,
      height: HANDLE_SIZE,
      background: "white",
      border: `2px solid ${color}`,
      boxSizing: "border-box",
      borderRadius: 2,
      cursor,
      pointerEvents: "auto",
      zIndex: 61
    }
  }
);
const isNum = (value) => typeof value === "number" && isFinite(value);
const rect = (left, top, right, bottom, imageWidth, imageHeight) => ({
  left: left * imageWidth,
  top: top * imageHeight,
  width: (right - left) * imageWidth,
  height: (bottom - top) * imageHeight
});
export { clamp01, clampToImage, orderedCoords, toleranceFromCorner };
export default RegionOverlay;
